import { UIText2 } from '@cian/ui-kit';
import { IconMapWalk16 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';

export const WalkWayMinutes: React.FC<React.PropsWithChildren> = props => {
  return (
    <div className={styles['container']}>
      <IconMapWalk16 display="block" color="gray60_100" />
      <UIText2 color="gray60_100">{props.children}</UIText2>
    </div>
  );
};
